import { imgUrl } from "../../lib/api";

export function itemTransform(it) {
  return {
    position: "absolute",
    left: 0,
    top: 0,
    width: it.width,
    height: it.height,
    transform: `translate(${it.x}px, ${it.y}px) rotate(${it.rotation || 0}deg)`,
    zIndex: it.z || 1,
  };
}

// Pure visual content of a board item (no selection / drag chrome).
export function BoardItemContent({ it }) {
  if (it.type === "image") {
    return (
      <div className="relative w-full h-full">
        <img src={imgUrl(it.src)} alt="" crossOrigin="anonymous" draggable={false}
          className="w-full h-full object-cover rounded-[2px] shadow-sm select-none pointer-events-none" />
        {it.attribution?.name && (
          <span className="absolute bottom-0 right-0 bg-black/45 text-white text-[8px] leading-none px-1 py-0.5 rounded-tl">
            {it.attribution.name} / Unsplash
          </span>
        )}
      </div>
    );
  }
  if (it.type === "color") {
    return (
      <div className="w-full h-full flex flex-col rounded-[2px] overflow-hidden shadow-sm">
        <div className="flex-1" style={{ background: it.color }} />
        <div className="bg-white px-1 py-0.5">
          <p className="text-[9px] font-medium truncate leading-tight">{it.label || ""}</p>
          <p className="text-[8px] text-zinc-400 uppercase leading-tight">{it.color}</p>
        </div>
      </div>
    );
  }
  // text
  return (
    <div className="w-full h-full flex items-center pointer-events-none" style={{ justifyContent: it.align === "center" ? "center" : it.align === "right" ? "flex-end" : "flex-start" }}>
      <p className={it.font_family === "heading" ? "font-heading" : ""}
        style={{ fontSize: it.font_size, color: it.color, fontWeight: it.bold ? 700 : 400, textAlign: it.align || "left", width: "100%", lineHeight: 1.15, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
        {it.text}
      </p>
    </div>
  );
}
